/* istanbul ignore file */
import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import getThemeById from "./themes/themeMapper";
import PageNotFound from "./components/PageNotFound/PageNotFound";
import { AppMainBox } from "./App-Styles";
import IframeResizer from "iframe-resizer-react";
import { startSession } from "./services/startSession/startSession";
import { get as _get } from "lodash";
import { getEnvironment, routeToHomePage, routeToMyAccount, trustedOrigins } from "./Utils/Utils";
import { AFLoadingSpinner } from "./components/LoadingSpinner/AFLoadingSpinner";
import { Grid } from "@mui/material";
import { datadogRum } from '@datadog/browser-rum';
import { DatadogResolver } from './Utils/DatadogResolver';
import packageInfo from '../package.json';

function App() {
  const [url, setUrl] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const query = new URLSearchParams(window.location.search);
  const opcoId = query.get("id") ?? "";

  const environment = getEnvironment();
  console.log(`ThirdParty FNOL - Version: ${packageInfo.version} Env: ${environment}`);
  datadogRum.init(DatadogResolver.resolveConfig(environment, packageInfo.version))

  // Retrieve the theme object
  let bodyContent = <PageNotFound />;

  // UseEffect handler for search suggestion
  useEffect(() => {
    const initiateSession = async () => {
      const crResponse = await startSession(opcoId);
      if (crResponse) {
        console.log(crResponse);
        setUrl(_get(crResponse, "data.url", ""));
      }
    };
    initiateSession();
  }, [opcoId]);

  window.addEventListener(
    "message",
    async (event) => {
      if (event.origin === "https://fnol-intake-int.amfam.com" || event.origin === "https://fnol-intake.amfam.com") {
        const code = _get(event, "data.messageName", "NO_MESSAGE_FOUND");
        switch (code) {
          case "FNOL_SESSION_TIMEOUT_ERROR":
            setIsLoading(true);
            const crResponse = await startSession(opcoId);
            if (crResponse) {
              console.log(crResponse);
              setUrl(_get(crResponse, "data.url", ""));
            }
            break;
          case "FNOL_STOP_SPINNER":
            setIsLoading(false);
            break;
          case "FNOL_ROUTE_HOMEPAGE":
            routeToHomePage(opcoId);
            break;
          case "FNOL_ROUTE_MYACCOUNT":
            routeToMyAccount(opcoId);
            break;
        }
      }
    },
    false
  );

  if (opcoId) {
    const activatedTheme = getThemeById(opcoId);
    if (activatedTheme) {
      bodyContent = (
        <ThemeProvider theme={activatedTheme}>
          <Grid container>
            <Grid item xs={12}>
              <Header />
            </Grid>
            <Grid item xs={12}>
              <AppMainBox>
                <IframeResizer
                  src={url}
                  style={{
                    width: "1px",
                    minWidth: "100%",
                    minHeight: "48em",
                    borderWidth: "0px",
                  }}
                  heightCalculationMethod="taggedElement"
                  scrolling={false}
                  checkOrigin={trustedOrigins}
                />
              </AppMainBox>
            </Grid>
            <Grid item xs={12}>
              <Footer />
            </Grid>
          </Grid>
          <AFLoadingSpinner isVisible={isLoading} />
        </ThemeProvider>
      );
    }
  }

  return <React.Fragment>{bodyContent}</React.Fragment>;
}

export default App;
